module.exports = ".fa-heart {\r\n    color: #dc0000;\r\n    text-shadow: 1px 2px 3px #840000;\r\n    -webkit-transition: all ease-out 0.3s;\r\n    transition: all ease-out 0.3s;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/chat/chat-reaction/chat-reaction.component.css
// module id = ./src/app/commons/chat/chat-reaction/chat-reaction.component.css
// module chunks = main